import * as React from "react";
import NavBar from "../components/NavBar";
import {AddOutlined, Remove, SearchOutlined} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {Divider} from "@mui/material";
import {handleSetQuery} from "../assets/js/main";
import {Link, useLocation, useSearchParams} from "react-router-dom";

export default function FAQ() {
  const {t} = useTranslation()
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [open, setOpen] = React.useState(true);
  const [categoryId, setCategoryId] = React.useState(1);
  const [collapseShow, setCollapseShow] = React.useState(null);
  const faqCategory = [
    {
      title: t("faq.t3"),
      id: 1
    },
    {
      title: t("faq.t4"),
      id: 2
    },
    {
      title: t("faq.t5"),
      id: 3
    },
    {
      title: t("faq.t6"),
      id: 4
    },
    {
      title: t("faq.t7"),
      id: 5
    },
    {
      title: t("faq.t8"),
      id: 6
    },
  ]

  const faqList = [
    {
      idParent: 1,
      items: [
        {
          title: t("faq.t9"),
          desc: t("faq.t10"),
          link: ''
        },
        {
          title: t("faq.t11"),
          desc: t("faq.t12"),
          link: '/tracking'
        },
        {
          title: t("faq.t13"),
          desc: t("faq.t14")
        },
        {
          title: t("faq.t15"),
          desc: t("faq.t16"),
          link: '/tracking'
        },
        {
          title: t("faq.t17"),
          desc: t("faq.t18")
        },
        {
          title: t("faq.t19"),
          desc: t("faq.t20")
        },
        {
          title: t("faq.t21"),
          desc: t("faq.t22")
        },
        {
          title: t("faq.t23"),
          desc: t("faq.t24")
        },
        {
          title: t("faq.t25"),
          desc: t("faq.t26")
        },
        {
          title: t("faq.t27"),
          desc: t("faq.t28")
        },
      ]
    },
    {
      idParent: 2,
      items: [
        {
          title: t("faq.t29"),
          desc: t("faq.t30"),
          link: '/tracking'
        },
        {
          title: t("faq.t31"),
          desc: t("faq.t32"),
          link: '/support'
        },
        {
          title: t("faq.t33"),
          desc: t("faq.t34")
        },
        {
          title: t("faq.t35"),
          desc: t("faq.t36")
        },
        {
          title: t("faq.t37"),
          desc: t("faq.t38")
        },
        {
          title: t("faq.t39"),
          desc: t("faq.t40")
        },
      ]
    },
    {
      idParent: 3,
      items: [
        {
          title: t("faq.t41"),
          desc: t("faq.t42"),
          link: '/support'
        },
        {
          title: t("faq.t43"),
          desc: t("faq.t44"),
          link: '/support'
        },
        {
          title: t("faq.t45"),
          desc: t("faq.t46"),
          link: '/support'
        },
        {
          title: t("faq.t47"),
          desc: t("faq.t48"),
          link: '/auth/login'
        },
        {
          title: t("faq.t49"),
          desc: t("faq.t50")
        },
        {
          title: t("faq.t51"),
          desc: t("faq.t52")
        },
        {
          title: t("faq.t53"),
          desc: t("faq.t54")
        },
        {
          title: t("faq.t55"),
          desc: t("faq.t56")
        },
      ]
    },
    {
      idParent: 4,
      items: [
        {
          title: t("faq.t57"),
          desc: t("faq.t58")
        },
        {
          title: t("faq.t59"),
          desc: t("faq.t60")
        },
        {
          title: t("faq.t61"),
          desc: t("faq.t62")
        },
      ]
    },
    {
      idParent: 5,
      items: [
        {
          title: t("faq.t63"),
          desc: t("faq.t64")
        },
        {
          title: t("faq.t65"),
          desc: t("faq.t66")
        },
        {
          title: t("faq.t67"),
          desc: t("faq.t68")
        },
        {
          title: t("faq.t69"),
          desc: t("faq.t70")
        },
        {
          title: t("faq.t71"),
          desc: t("faq.t72")
        },
      ]
    },
    {
      idParent: 6,
      items: [
        {
          title: t("faq.t73"),
          desc: t("faq.t74"),
          link: '/representation'
        },
        {
          title: t("faq.t75"),
          desc: t("faq.t76"),
          link: '/representation'
        },
      ]
    },
  ]

  const [faq, setFAQ] = React.useState(faqList);
  const [faqSearch, setFAQSearch] = React.useState([]);


  const handleSearch = (i) => {
    if (i) {
      let search = []
      faqList.map(item => item?.items?.map(item1 => {
        if (item1.title.includes(i) || item1.desc.includes(i)) {
          search.push(item1)
        }
      }))
      setFAQSearch(search)
    } else {
      setFAQSearch([])
      setFAQ(faqList)
    }
  }


  return (
     <>
       <NavBar blue back/>

       <div className="container">
         <div className="faqPage desktopSection">
           <div className="search">
             <h4 className="titleSection">{t("faq.t1")}</h4>

             <div>
               <input type="text" name="search" placeholder={t("faq.t2")} onChange={(e) => handleSearch(e.target.value)} id="search"/>
               <SearchOutlined/>
             </div>
           </div>

           {
             !faqSearch?.length && <>

               <div className="category">
                 {
                   faqCategory?.map(item => {
                     return <button className={categoryId === item.id ? 'active' : null} type="button" key={item?.id}
                                    onClick={() => setCategoryId(item?.id)}
                                    id="faqCategory"
                     >
                       <span>{item?.title}</span>
                     </button>
                   })
                 }
               </div>

               <Divider/>
             </>
           }

           <div className="row">
             {
               !faqSearch?.length ?
                  <div className="col-12 col-lg-8">
                    {
                      faq?.map((item, index) => {
                        return (
                           item?.idParent === categoryId &&
                           <div className="listFAQ" key={index}>
                             {
                               item?.items?.map((item1, index1) => {
                                 return (
                                    <div className="collapse-div">
                                      <button type="button" onClick={() => setCollapseShow(collapseShow === index1 ? null : index1)} id="collapse">
                                        {
                                          collapseShow === index1 ?
                                             <Remove/>
                                             :
                                             <AddOutlined/>
                                        }
                                        {item1?.title}
                                      </button>
                                      { collapseShow === index1 &&
                                      <div>
                                        <div className="content">
                                          {item1?.desc}
                                          <br/>
                                          {
                                            item1?.link &&
                                            <Link to={{pathname: item1?.link, search: location?.search}} id="links">
                                              <span>{t("faq.t80")}</span>
                                            </Link>
                                          }
                                        </div>


                                      </div>}
                                    </div>
                                 )
                               })
                             }
                           </div>

                        )
                      })
                    }
                  </div>
                  :
                  <div className="col-12 col-lg-8">
                    {
                      faqSearch?.map((item, index) => {
                        return (
                           <div className="listFAQ" key={index}>
                             <div className="collapse-div">
                               <button type="button" onClick={() => setCollapseShow(collapseShow === index ? null : index)} id="showCollapseShow">
                                 {
                                   collapseShow === index ?
                                      <Remove/>
                                      :
                                      <AddOutlined/>
                                 }
                                 {item?.title}
                               </button>
                               { collapseShow === index &&
                               <div>
                                 <div className="content">
                                   {item?.desc}
                                   <br/>
                                   {
                                     item?.link &&
                                     <Link to={{pathname: item?.link, search: location?.search}} id="content">
                                       <span>{t("faq.t80")}</span>
                                     </Link>
                                   }
                                 </div>

                               </div>}
                             </div>
                           </div>
                        )
                      })
                    }
                  </div>
             }
             <div className="col-12 col-lg-4 d-none d-lg-block">
               <div className="faq-support">
                 <svg width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path
                      d="M104.475 97.4027C109.466 91.9262 112.16 84.7408 112 77.3333C112.141 71.8442 110.706 66.4296 107.863 61.7316C105.021 57.0336 100.891 53.2491 95.9631 50.8267C95.9631 51.072 96.0004 51.3067 96.0004 51.552C96.0004 73.7867 78.0911 87.1253 56.0004 87.1253C51.8846 87.1396 47.7826 86.6471 43.7871 85.6587C47.5204 99.8987 61.1204 108.165 77.3284 108.165C82.0265 108.207 86.6975 107.449 91.1418 105.925C93.7406 108.186 96.7769 109.888 100.062 110.925C103.346 111.961 106.809 112.311 110.235 111.952C110.603 111.942 110.959 111.821 111.256 111.604C111.553 111.388 111.777 111.085 111.899 110.738C112.02 110.391 112.033 110.015 111.936 109.66C111.839 109.306 111.637 108.989 111.355 108.752C107.734 105.952 105.283 101.908 104.475 97.4027Z"
                      fill="#009BDE"/>
                   <path opacity="0.4"
                         d="M96.0001 51.568C96.0001 51.3227 95.9681 51.088 95.9628 50.8427C95.5628 29.056 77.8668 16 56.0001 16C33.9094 16 16.0001 29.3333 16.0001 51.568C15.8139 60.1158 18.9162 68.409 24.6668 74.736C23.7409 79.9227 20.9223 84.581 16.7574 87.808C16.4392 88.0873 16.2113 88.4549 16.1026 88.8641C15.994 89.2733 16.0096 89.7056 16.1474 90.1059C16.2853 90.5063 16.5391 90.8565 16.8766 91.1122C17.2141 91.3678 17.6201 91.5172 18.0428 91.5413C21.9926 91.9486 25.9839 91.5391 29.7686 90.338C33.5534 89.137 37.0506 87.1702 40.0428 84.56C41.2588 84.9813 42.5121 85.3547 43.7761 85.6747C47.7716 86.6631 51.8736 87.1557 55.9894 87.1413C78.0854 87.1413 96.0001 73.8027 96.0001 51.568Z"
                         fill="#009BDE"/>
                   <path
                      d="M55.637 56.4694C54.9366 56.4729 54.2424 56.3384 53.594 56.0736C52.9456 55.8088 52.3557 55.4189 51.8579 54.9262C50.8527 53.931 50.2841 52.5772 50.277 51.1627C50.2699 49.7482 50.825 48.3889 51.8202 47.3837C52.8154 46.3785 54.1692 45.8098 55.5836 45.8027H55.637C57.0515 45.8027 58.408 46.3646 59.4082 47.3648C60.4084 48.365 60.9703 49.7216 60.9703 51.1361C60.9703 52.5506 60.4084 53.9071 59.4082 54.9073C58.408 55.9075 57.0515 56.4694 55.637 56.4694ZM43.3063 51.1361C43.3063 49.7216 42.7444 48.365 41.7442 47.3648C40.744 46.3646 39.3875 45.8027 37.973 45.8027H37.9197C36.8672 45.8133 35.8413 46.135 34.9713 46.7274C34.1013 47.3198 33.426 48.1564 33.0305 49.1318C32.635 50.1072 32.5369 51.1778 32.7487 52.2089C32.9605 53.2399 33.4726 54.1852 34.2206 54.9258C34.9685 55.6663 35.9189 56.169 36.952 56.3705C37.985 56.572 39.0547 56.4633 40.0261 56.0581C40.9975 55.6529 41.8273 54.9694 42.4111 54.0935C42.9948 53.2176 43.3063 52.1886 43.3063 51.1361ZM78.5383 51.1361C78.5383 49.7216 77.9764 48.365 76.9762 47.3648C75.976 46.3646 74.6195 45.8027 73.205 45.8027H73.1516C72.0991 45.8133 71.0733 46.135 70.2033 46.7274C69.3333 47.3198 68.658 48.1564 68.2625 49.1318C67.867 50.1072 67.7689 51.1778 67.9807 52.2089C68.1925 53.2399 68.7046 54.1852 69.4526 54.9258C70.2005 55.6663 71.1509 56.169 72.184 56.3705C73.217 56.572 74.2867 56.4633 75.2581 56.0581C76.2295 55.6529 77.0593 54.9694 77.6431 54.0935C78.2268 53.2176 78.5383 52.1886 78.5383 51.1361Z"
                      fill="#009BDE"/>
                 </svg>

                 <p>{t("faq.t77")}</p>
                 <span>{t("faq.t78")}</span>

                 <div className="btnGroup_blue mb-0">
                   <Link to={{pathname: '/singleOrder', search: location?.search}} className="btnFill w-100 justify-content-center" type="button" id="singleOrder">
                     <span>{t("faq.t79")}</span>
                   </Link>
                 </div>
               </div>
             </div>
           </div>


         </div>
       </div>

     </>
  )
}
